import React from "react";
import { Button } from "@deliverr/ui";
import { ModalTemplate, SoundFx } from "@deliverr/ui-facility";
import { FormattedMessage } from "react-intl";
import { useSortationModal } from "sortation/components/SortationModal";
import { sortationDangerIconProps } from "sortation/components/SortationModal/sortationModalIconProps";
import { CustomsScanModal } from "./CustomsScanModal";

export const MasterCartonBarcodeInvalidModal: React.FC = () => {
  const { hideModal } = useSortationModal();

  return (
    <ModalTemplate
      title={
        <FormattedMessage
          id="sortation.customsScan.maserCartonBarcodeInvalidModal.title"
          defaultMessage="Master Carton Barcode Is Invalid"
        />
      }
      text={
        <FormattedMessage
          id="sortation.customsScan.maserCartonBarcodeInvalidModal.body"
          defaultMessage={"The scanned master carton barcode is invalid. Please contact a supervisor for assistance. "}
        />
      }
      iconProps={sortationDangerIconProps}
      soundFx={SoundFx.ERROR_FAST}
    >
      <Button block onClick={() => hideModal(CustomsScanModal.MASTER_CARTON_BARCODE_INVALID)}>
        <FormattedMessage
          id="sortation.customsScan.maserCartonBarcodeInvalidModal.continue"
          defaultMessage="Continue"
        />
      </Button>
    </ModalTemplate>
  );
};
